import type { App } from 'vue';
import Vue3TouchEvents, {
  type Vue3TouchEventsOptions,
} from 'vue3-touch-events';

export function setupTouchEvents(app: App) {
  app.use<Vue3TouchEventsOptions>(Vue3TouchEvents, {});
}
